import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

type ModalType = "settings" | "user-info" | "line-settings" | null;

/**
 * URLパラメータベースのモーダルルーティングを管理するカスタムフック
 */
export const useModalRouting = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const modalType = (searchParams.get("modal") as ModalType) || null;

  const [isSettingsMenuOpen, setIsSettingsMenuOpen] = useState(false);
  const [isUserMenuModalOpen, setIsUserMenuModalOpen] = useState(false);
  const [isLineDeliverySettingsModalOpen, setIsLineDeliverySettingsModalOpen] = useState(false);

  // URLパラメータの変化を監視してモーダルを開く
  useEffect(() => {
    setIsSettingsMenuOpen(modalType === "settings");
    setIsUserMenuModalOpen(modalType === "user-info");
    setIsLineDeliverySettingsModalOpen(modalType === "line-settings");
  }, [modalType]);

  // モーダルを閉じる際にURLパラメータを削除
  const closeModal = () => {
    searchParams.delete("modal");
    setSearchParams(searchParams);
  };

  // 各モーダルの状態変更ハンドラー
  const handleSettingsMenuChange = (open: boolean) => {
    setIsSettingsMenuOpen(open);
    if (!open && modalType === "settings") {
      closeModal();
    }
  };

  const handleUserMenuModalChange = (open: boolean) => {
    setIsUserMenuModalOpen(open);
    if (!open && modalType === "user-info") {
      closeModal();
    }
  };

  const handleLineDeliverySettingsModalChange = (open: boolean) => {
    setIsLineDeliverySettingsModalOpen(open);
    if (!open && modalType === "line-settings") {
      closeModal();
    }
  };

  // ナビゲーションヘルパー
  const openSettingsMenu = () => {
    setSearchParams({ modal: "settings" });
  };

  const navigateToUserInfo = () => {
    setSearchParams({ modal: "user-info" });
  };

  const navigateToLineSettings = () => {
    setSearchParams({ modal: "line-settings" });
  };

  return {
    // モーダルの開閉状態
    isSettingsMenuOpen,
    isUserMenuModalOpen,
    isLineDeliverySettingsModalOpen,
    // 状態変更ハンドラー
    handleSettingsMenuChange,
    handleUserMenuModalChange,
    handleLineDeliverySettingsModalChange,
    // ナビゲーションヘルパー
    openSettingsMenu,
    navigateToUserInfo,
    navigateToLineSettings
  };
};
